<template>
  <div>
    <mt-header :title="$t('自定义排序')" class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <mt-cell :title="$t('货币')">
      <span>{{$t('拖动排序')}}</span>
    </mt-cell>
    <draggable v-model="list">
        <div v-for="(item, index) in list" class="list_item dl_line_bottom" :key="index">
          <div class="content_item">
            <div class="item1">
              <span class="coin">{{item.coin}}</span>
              <span class="dl_font2_color currency">/{{item.currency}}</span>
            </div>
            <span class="dl_font2_color item1 exchange">{{item.exchange_name}}</span>
          </div>
          <div class="content_item" style="height:1px"></div>
          <div class="content_item" style="height:1px"></div>
          <div class="content_item">
            <img class="paixu" src="@/assets/img/ico_paixu_hangqing.png">
          </div>
        </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { Toast } from "mint-ui";
import { httpGetHangqingList, httpSortHangqing } from "@/api/hangqing";
var unwatch;
export default {
  name: "Sortable",
  components: { Toast, draggable },
  data() {
    return {
      list: []
    };
  },
  created() {},
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    getList: function() {
      var p = {
        currency: this.$store.state.currency
      };
      httpGetHangqingList(p)
        .then(res => {
          this.list = res.data.list;
          unwatch = this.$watch("list", this.onSortChange);
        })
        .catch(() => {});
    },
    onSortChange: function(val, old) {
      
      var t = val.map(function(item) {
        return item.id;
      });
      httpSortHangqing({ ids: t.join(",") })
        .then(res => {})
        .catch(() => {});
    }
  },
  computed: {},
  watch: {},
  activated: function() {
    this.getList();
  },
  beforeRouteLeave(to, from, next) {
    if(unwatch != undefined){
      unwatch()
    }
    next();
  }
};
</script>

<style scoped>
.container {
  padding: 0px 10px 10px 10px;
}
.head_search {
  height: 50px;
}
.paixu {
  height: 20px;
  margin-top: 10px;
}
.list_item {
  height: 60px;
  padding-top: 10px;
  box-sizing: border-box;
}
.content_item {
  display: inline-block;
  width: 25%;
  text-align: center;
  font-size: 12px;
  line-height: 40px;
  float: left;
}
.content_item .item1 {
  line-height: 20px;
  display: block;
}
.coin {
  font-size: 14px;
  font-weight: 700;
}
.exchange{
  font-weight: 500;
}
.mint-cell-title span{
  font-weight: 700;
}
.currency {
  font-size: 10px;
  font-weight: 400;
}
</style>

